import { Stack, Text } from "@smartsuite/react-ui/lib";
import type React from "react";
import { $t } from "../../utils/intl";
import { messages } from "./FormNoPermissions.text";

import "./FormNoPermissions.sass";

const LockIcon: React.FC = () => (
  <svg width="24" height="30" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.43583 30C1.77167 30 1.19972 29.76 0.72 29.28C0.24 28.8003 0 28.2283 0 27.5642V12.5171C0 11.8418 0.24 11.2671 0.72 10.7929C1.19972 10.3185 1.77167 10.0813 2.43583 10.0813H5.12833V6.53833C5.12833 4.71694 5.76306 3.17194 7.0325 1.90333C8.30222 0.634444 9.84847 0 11.6712 0C13.4937 0 15.0383 0.634444 16.305 1.90333C17.5717 3.17194 18.205 4.71694 18.205 6.53833V10.0813H20.8975C21.5617 10.0813 22.1336 10.3185 22.6133 10.7929C23.0933 11.2671 23.3333 11.8418 23.3333 12.5171V27.5642C23.3333 28.2283 23.0933 28.8003 22.6133 29.28C22.1336 29.76 21.5617 30 20.8975 30H2.43583ZM2.43583 28.5896H20.8975C21.1967 28.5896 21.4424 28.4935 21.6346 28.3013C21.8268 28.109 21.9229 27.8633 21.9229 27.5642V12.5171C21.9229 12.2179 21.8268 11.9722 21.6346 11.78C21.4424 11.5875 21.1967 11.4912 20.8975 11.4912H2.43583C2.13667 11.4912 1.89097 11.5875 1.69875 11.78C1.50653 11.9722 1.41042 12.2179 1.41042 12.5171V27.5642C1.41042 27.8633 1.50653 28.109 1.69875 28.3013C1.89097 28.4935 2.13667 28.5896 2.43583 28.5896ZM13.4096 21.7858C13.8874 21.31 14.1263 20.7325 14.1263 20.0533C14.1263 19.3917 13.8858 18.8143 13.405 18.3213C12.9244 17.8279 12.3435 17.5813 11.6621 17.5813C10.9807 17.5813 10.4013 17.8279 9.92375 18.3213C9.44597 18.8143 9.20708 19.3964 9.20708 20.0675C9.20708 20.7383 9.4475 21.3114 9.92833 21.7867C10.4089 22.2622 10.9899 22.5 11.6712 22.5C12.3526 22.5 12.9321 22.2619 13.4096 21.7858ZM6.53833 10.0813H16.795V6.53833C16.795 5.11389 16.2968 3.90306 15.3004 2.90583C14.3043 1.90889 13.0946 1.41042 11.6712 1.41042C10.2479 1.41042 9.03667 1.90889 8.0375 2.90583C7.03806 3.90306 6.53833 5.11389 6.53833 6.53833V10.0813Z"
      fill="#1C1B1F"
    />
  </svg>
);

export const FormNoPermissions: React.FC = () => {
  return (
    <div className="form-no-permissions">
      <div className="form-no-permissions__icon">
        <LockIcon />
      </div>

      <Stack isRow={false} gap={5}>
        <Text size="l" weight="medium" align="center" color="primary">
          {$t(messages.title)}
        </Text>
        <Text size="m" weight="regular" align="center" color="tertiary">
          {$t(messages.description)}
        </Text>
      </Stack>
    </div>
  );
};
